module.exports = __webpack_public_path__ + "img/hilmore-house.6bbd5c38.png";